// extracted by mini-css-extract-plugin
export var active = "_b5-d";
export var blink = "_b5-e";
export var container = "_b5-5";
export var controls = "_b5-0";
export var controlsRight = "_b5-1";
export var fakeCursor = "_b5-c";
export var hidden = "_b5-b";
export var quillContainerSmall = "_b5-7";
export var quillEditor = "_b5-6";
export var quillEditorSmall = "_b5-8";
export var quillFormatButtons = "_b5-a";
export var quillToolbar = "_b5-9";
export var removePadding = "_b5-2";
export var state = "_b5-3";
export var stateTitle = "_b5-4";